import { API } from "aws-amplify";
import Auth from "@aws-amplify/auth";
import { store } from "../../store";

const getHeaders = async () => {
  const user = await Auth.currentAuthenticatedUser();
  const jwtToken = user.signInUserSession?.accessToken?.jwtToken;
  const headers = {};
  if (jwtToken) headers['Authorization'] = 'Bearer ' + jwtToken;
  const { loginReducer } = store.getState();
  const clientId = loginReducer?.groups?.[0];
  if (clientId) headers['BluStream-Client-ID'] = clientId;
  return headers;
};

const customerUuid = () => {
  const { loginReducer } = store.getState();
  return loginReducer?.groups?.[0];
};

// GET /api/research/customers/{uuid}/requests?status={status}
// Returns list of research requests, optionally filtered by status
export const getResearchRequests = async (status) => {
  const uuid = customerUuid();
  const headers = await getHeaders();
  const params = new URLSearchParams();
  if (status && status !== 'all') params.set('status', status);
  const qs = params.toString();
  return API.get("blustreamREST", `/gandalfproxy/api/research/customers/${uuid}/requests${qs ? '?' + qs : ''}`, { headers });
};

// GET /api/research/requests/{id}?customerUuid=...
// Returns full research request detail
export const getResearchRequest = async (id) => {
  const uuid = customerUuid();
  const headers = await getHeaders();
  return API.get("blustreamREST", `/gandalfproxy/api/research/requests/${id}?customerUuid=${uuid}`, { headers });
};

// PUT /api/research/requests/{id}/validate?customerUuid=...
// Body: { validatedAnswer, validatedByUserId }
export const validateResearchRequest = async (id, answer, userId) => {
  const uuid = customerUuid();
  const headers = await getHeaders();
  return API.put("blustreamREST", `/gandalfproxy/api/research/requests/${id}/validate?customerUuid=${uuid}`, { headers, body: { validatedAnswer: answer, validatedByUserId: userId } });
};

// PUT /api/research/requests/{id}/close?customerUuid=...
export const closeResearchRequest = async (id) => {
  const uuid = customerUuid();
  const headers = await getHeaders();
  return API.put("blustreamREST", `/gandalfproxy/api/research/requests/${id}/close?customerUuid=${uuid}`, { headers });
};

// POST /api/research/requests/{id}/retry
export const retryResearchRequest = async (id) => {
  const headers = await getHeaders();
  return API.post("blustreamREST", `/gandalfproxy/api/research/requests/${id}/retry`, { headers });
};

// POST /api/research/requests/{id}/ingest-rag?customerUuid=...
export const ingestResearchToRag = async (id, documents) => {
  const uuid = customerUuid();
  const headers = await getHeaders();
  return API.post("blustreamREST", `/gandalfproxy/api/research/requests/${id}/ingest-rag?customerUuid=${uuid}`, { headers, body: { documents } });
};

// POST /api/research/requests/{id}/check-guards
// Returns guard evaluation results including per-contact outcomes
export const checkResearchGuards = async (id) => {
  const uuid = customerUuid();
  const headers = await getHeaders();
  return API.post("blustreamREST", `/gandalfproxy/api/research/requests/${id}/check-guards?customerUuid=${uuid}`, { headers });
};

// GET /api/research/requests/{id}/activity?customerUuid=...
// Returns activity log for a research request
export const getResearchActivityLog = async (id) => {
  const uuid = customerUuid();
  const headers = await getHeaders();
  return API.get("blustreamREST", `/gandalfproxy/api/research/requests/${id}/activity?customerUuid=${uuid}`, { headers });
};

// GET /api/research/customers/{uuid}/requests?conversationId={conversationId}
// Returns research request linked to a specific conversation, or null if none
export const getResearchByConversation = async (conversationId) => {
  const uuid = customerUuid();
  const headers = await getHeaders();
  const res = await API.get("blustreamREST", `/gandalfproxy/api/research/customers/${uuid}/requests?conversationId=${conversationId}`, { headers });
  const list = Array.isArray(res) ? res : res.content || res.requests || [];
  return list.length > 0 ? list[0] : null;
};

// GET /api/research/customers/{uuid}/requests?status=pending — returns count
// Used by notification hook to poll for pending research count
export const getPendingResearchCount = async () => {
  const uuid = customerUuid();
  const headers = await getHeaders();
  const res = await API.get("blustreamREST", `/gandalfproxy/api/research/customers/${uuid}/requests?status=pending`, { headers });
  const list = Array.isArray(res) ? res : res.content || res.requests || [];
  return list.length;
};
